export default __webpack_public_path__ + "static/media/IC00007-webinar_card.5b0559ae.svg";